import React, { useState, useEffect } from "react";
import DateTimePicker from "react-datetime-picker";
import CalendarIcon from "../../Resources/svg/date-picker.svg";
import {
  validateOnlyNumbers,
  validateOnlyLetters,
  validateDniSimulations,
  calcDaysPassed,
  validateEmail,
  isUnderage
} from "../../Utils/validators";
import { relations, typeDocumentListAsInsured, defaultPhoneNumber } from "../../Utils/constants";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import { API } from "aws-amplify";
import RadioButtonsComponent from "../../Components/radioButtonsComponent";
import { camposOpcionalesBeneficiario } from "../../Utils/utils";
import { DualRing } from "react-loading-io";
import { Ubigeo } from "./ubigeo";
import { useForm, FormContext, Controller } from "react-hook-form";
export interface Props {
  beneficiary: object;
  index: number;
  updateBeneficiary: Function;
  removeBeneficiary: Function;
  count: number;
  existsErrors: boolean;
  handleCalcOnBlur: any;
  productCode?: any
}

export const BeneficiaryForm = ({
  beneficiary,
  index,
  updateBeneficiary,
  removeBeneficiary,
  count,
  existsErrors,
  handleCalcOnBlur,
  productCode
}: Props) => {

  const methods = useForm({ mode: "onChange" });
  const code = productCode.producto.codigo
  const [nameUbigeo, setNameUbigeo] = useState<any>({
    province: "",
    department: "",
    district: "",
  });
  const [data, setData] = useState<any>(beneficiary);
  const [errors, setErrors] =useState<any>({
    tipoDoc: existsErrors,
    documento: existsErrors,
    nombres: existsErrors,
    apePaterno: existsErrors,
    apeMaterno: existsErrors,
    fecNacimiento: existsErrors,
    sexo: existsErrors,
    numCelular: existsErrors,
    correoElectronico: existsErrors,
    idRelacion: existsErrors,
    porcentaje: existsErrors,
  });

  const [dataTypeDoc, setDataTypeDoc] = useState<any>("");
  const [selectDate, setSelectDate] = useState<any>();
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorDate, setErrorDate] = useState<any>(null);
  const [underage, setUnderage] = useState<boolean>(false);

  useEffect(() => {
    setData(beneficiary);
  }, [beneficiary]);

  useEffect(() => {
    handleChange({target: {name: 'nameUbigeo', value: nameUbigeo}})
  }, [nameUbigeo])


  
  const parseDate = (dateString: string) => {
    const [day, month, year] = dateString.split("/");
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  };

  const formatDateString = (date: Date) => {
    return new Intl.DateTimeFormat("es-PE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  };

  const validate = (name: any, value: any) => {
    let valid = true;
    switch (name) {
      case "documento":
        if (value.toString().length < 8) {
          valid = false;
        }
        break;
      case "porcentaje":
        if (isNaN(value) || value.toString().length < 1) {
          valid = false;
        } else {
          if (parseFloat(value) <= 0 || parseFloat(value) > 100) {
            valid = false;
          }
        }
        break;
      case "tipoDoc":
      case "fecNacimiento":
      case "sexo":
      case "nombres":
      case "apePaterno":
      // case "apeMaterno":
      case "idRelacion":
        break;
      case "numCelular":
          if (value.toString().length !== 9) {
            valid = false;
          }
          break;
      case "correoElectronico":
        if(value.length == 0){
          valid = true;
        } else if(value.length > 0 && validateEmail(value)){
          valid = false;
        }
        break;
    }
    errors[name] = !valid;
    setErrors(errors);
  };


  const handleChange = async (e: any) => {
    const { name, value } = e.target;

    let typeDoc;

    let newValue = value;
    const clon = { ...data };
    clon[name] = newValue; //agregado para renderizar UI sin esperar await
    setData({ ...clon });

    if (name === "porcentaje") {
      if (value === "" || !validateOnlyNumbers(newValue)) {
        newValue = "";
      } else {
        if (parseFloat(value) < 1 || parseFloat(newValue) > 100) {
          newValue = "";
        }
      }
    } else if (name === "tipoDoc") {
      typeDoc = value;
      setDataTypeDoc(typeDoc);
    } else if (name === "documento") {
      if (newValue !== "" && !validateDniSimulations(newValue, dataTypeDoc)) {
        newValue = data[name];
      }
      // if (newValue !== "" && !validateOnlyAlphanumeric(newValue)) {
      //   newValue = data[name];
      // }
    } else if (
      name === "nombres" ||
      name === "apePaterno" ||
      name === "apeMaterno"
    ) {
      if (newValue !== "" && !validateOnlyLetters(newValue)) {
        newValue = data[name];
      }
    } else if (name === "numCelular") {
      if (!/^\d*$/.test(newValue) || newValue.length > 9) {
        newValue = data[name];
      }
    } 

    if(name === "documento"){
      if((value.toString().length == 8 && dataTypeDoc === "2") || (value.toString().length >= 9 && dataTypeDoc === "1" || value.toString().length >= 8 && dataTypeDoc === "3")){
        try {
          const dataClient = await getDataClient(value);
          if (dataClient) {
            clon["documento"] = value;
            clon["nombres"] = dataClient.nombres;
            clon["apePaterno"] = dataClient.apellidoPaterno;
            clon["apeMaterno"] = dataClient.apellidoMaterno;
            clon["fecNacimiento"] = formatDateString(parseDate(dataClient.fecNacimiento));
            clon["sexo"] = dataClient.sexo;
            setSelectDate(parseDate(dataClient.fecNacimiento));
            clon["idTercero"] = dataClient.idetercero ? dataClient.idetercero : '';
            setIsDataLoaded(true);

            errors["documento"] = false;
            errors["nombres"] = false;
            errors["apePaterno"] = false;
            errors["apeMaterno"] = false;
            errors["fecNacimiento"] = false;
            errors["sexo"] = false;

            if(dataClient.correo && dataClient.correo.length > 0){
              clon["correoElectronico"] = dataClient.correo;
              errors["correoElectronico"] = false;
            }
            if(dataClient.celular  && dataClient.celular.length > 0){
              clon["numCelular"] = dataClient.celular;
              errors["numCelular"] = false;
            }
            if(clon["fecNacimiento"] && isUnderage(clon["fecNacimiento"])){
              setUnderage(true);
              clon["numCelular"] = phoneNumberClient;
              errors["numCelular"] = false;
              clon["correoElectronico"] = '';
              errors["correoElectronico"] = false;
            }else{
              setUnderage(false);
            }
          }else{
            setIsDataLoaded(false);
            clon["nombres"] = '';
            clon["apePaterno"] = '';
            clon["apeMaterno"] = '';
            clon["fecNacimiento"] = '';
            clon["sexo"] = '';
            clon["numCelular"] = '';
            clon["correoElectronico"] = '';
            clon["idTercero"] = '';
            setSelectDate(null);
            setUnderage(false);
          }
        } catch (error) {
          console.error(error);
        }
      } else if (value.length < 8) {
        setIsDataLoaded(false);
        clon["nombres"] = '';
        clon["apePaterno"] = '';
        clon["apeMaterno"] = '';
        clon["fecNacimiento"] = '';
        clon["sexo"] = '';
        clon["numCelular"] = '';
        clon["correoElectronico"] = '';
        clon["idTercero"] = '';
        setSelectDate(null);
        setUnderage(false);
      }
    }

    clon[name] = newValue;
    setData(clon);
    validate(name, newValue);
    let errorValidation = false;
    Object.entries(errors).some((item) => {
      if (item[1] && !camposOpcionalesBeneficiario.includes(item[0])) {
        errorValidation = true;
        return true;
      }
    });
    updateBeneficiary(clon, index, errorValidation);
  };

  
  const getDataClient = async (value: any) => {
    const params = {
      numDocumento: value,
      tipoDocumento: dataTypeDoc,
    }

    try {
      setLoading(true);
      const response = await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      });
      setLoading(false);
      if (response.status === 200 && response.data && response.success) {
        return response.data;
      } 
      
      return null;
    } catch (error) {
      setLoading(false);
      return null;
    }
  }
  const handleDateChange = (date: any) => {
    const dateCalc = calcDaysPassed(date)
    const clon = { ...data };
    if (dateCalc > 0) {
      setErrorDate("La fecha no debe ser mayor al día de hoy");
      setSelectDate(date);
      clon.fecNacimiento = {}
      updateBeneficiary(clon, index, true);
      errors["fecNacimiento"] = true;
    } else {
      setErrorDate(null)
      setSelectDate(date);

      const transformDate = new Intl.DateTimeFormat("es-PE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
      clon.fecNacimiento = transformDate
      if(isUnderage(transformDate)){
        setUnderage(true);
        clon["numCelular"] = phoneNumberClient;
        errors["numCelular"] = false;
        clon["correoElectronico"] = '';
        errors["correoElectronico"] = false;
      } else {
        setUnderage(false);
      }

      setData(clon);
      updateBeneficiary(clon, index, false);
      errors["fecNacimiento"] = false;
    }
  }

  const remove = (e: any) => {
    e.preventDefault();
    removeBeneficiary(index);
  };

  const typeInputDoc = dataTypeDoc === "2" ? 'number' : 'text';
  const phoneNumberClient = productCode.datosCliente.datosParticulares.mobile ? productCode.datosCliente.datosParticulares.mobile : defaultPhoneNumber;
  return (
    <div
      /*key={item.id}*/ className={`beneficiaryForm${
        index === 0 ? " first" : ""
      }`}
      style={{ position: 'relative' }}
    >
      {loading && (
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255, 255, 255, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
          <DualRing size={50} />
        </div>
      )}
      <div className="clientForm__beneficiary-box">
        <div className="clientForm__beneficiary-box-icon">
          <IconBeneficiario />
          <div className="clientForm__beneficiary">
            Beneficiario {index + 1}
          </div>
        </div>
        {count > 1 && (
          <p
            className="clientForm__eliminar"
            onClick={(e) => {
              remove(e);
            }}
          >
            Eliminar
          </p>
        )}
      </div>
      <div>

        <div className="clientForm__control__inputSelect" style={{ marginTop: "1rem" }}>
          <select name={`tipoDoc`} onChange={(e) => handleChange(e)} disabled={isDataLoaded}>
            <option value="" disabled selected>
              Documento
            </option>
            {typeDocumentListAsInsured && typeDocumentListAsInsured.map((item, index) => (
              <option key={index} value={item.value}>{item.name}</option>
            ))}
          </select>
          <div className="clientForm__control input-field">
            <input
              type={typeInputDoc}
              autoComplete="off"
              id={`documento_${index}`}
              name={`documento`}
              value={data.documento}
              onChange={(e) => handleChange(e)}
              maxLength={ dataTypeDoc == "2" ? 8 : 15}
              disabled={dataTypeDoc.length == 0}
            />
            <label htmlFor={`documento_${index}`}>Nro Documento</label>
          </div>
        </div>
        <div className="clientForm__control input-field">
          <input
            type="text"
            autoComplete="off"
            id={`nombres_${index}`}
            name={`nombres`}
            value={data.nombres}
            onChange={(e) => handleChange(e)}
            maxLength={30}
            disabled={isDataLoaded}
          />
          <label htmlFor={`nombres_${index}`} className={`${isDataLoaded ? 'active':''}`}>Nombres</label>
        </div>
        <div className="clientForm__control input-field">
          <input
            type="text"
            autoComplete="off"
            id={`apePaterno_${index}`}
            name={`apePaterno`}
            value={data.apePaterno}
            onChange={(e) => handleChange(e)}
            maxLength={30}
            disabled={isDataLoaded}
          />
          <label htmlFor={`apePaterno_${index}`} className={`${isDataLoaded ? 'active':''}`}>Apellido paterno</label>
        </div>
        <div className="clientForm__control input-field">
          <input
            type="text"
            autoComplete="off"
            id={`apeMaterno_${index}`}
            name={`apeMaterno`}
            value={data.apeMaterno}
            onChange={(e) => handleChange(e)}
            maxLength={30}
            disabled={isDataLoaded}
          />
          <label htmlFor={`apeMaterno_${index}`} className={`${isDataLoaded ? 'active':''}`}>Apellido Materno</label>
        </div>
        
        {!isDataLoaded && (
          <div className={`clientForm__control input-field`}>
            <div
              className={` area--${(1 % 5) % 4
                } child`}
            >
              <div
                className={`datapicker-single`}
              >
                <div className="datapicker-single__body">
                  <div>
                    <label className="datapicker__label">
                      Fecha de nacimiento
                    </label>
                  </div>
                  <DateTimePicker
                    name="fecNacimiento"
                    value={selectDate}
                    format="dd-MM-yy"
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yy"
                    onChange={(e: any) => handleDateChange(e)}
                    calendarIcon={
                      <img src={CalendarIcon} />
                    }
                    clearIcon={null}
                  />
                </div>
              </div>
            </div>
            {errorDate && <div className="errorCustom">{errorDate}</div>}
          </div>
        )
        }

        {
          isDataLoaded && (
            <div className="clientForm__control input-field">
              <input
                type="text"
                autoComplete="off"
                id={`fecNacimiento_${index}`}
                name={`fecNacimiento`}
                value={formatDateString(selectDate)}
                onChange={(e) => handleChange(e)}
                maxLength={30}
                disabled={isDataLoaded}
              />
              <label htmlFor={`fecNacimiento_${index}`} className={`${isDataLoaded ? 'active':''}`}>Fecha de nacimiento</label>
            </div>
          )
        }


        <div className="clientForm__control">
          <label className="clientForm__label" htmlFor="sexo" style={{marginTop: '1rem'}}>
                  ¿Cuál es su sexo?
          </label>
          <RadioButtonsComponent
            handleChange={(e: any) => handleChange(e)}
            handleBlur={()=>{}}
            name={`sexo_${index}`}
            defaultValue={data.sexo}
            disabled={isDataLoaded}
            items={[
              {
                id: `fem_${index}`,
                value: 'F',
                span: 'Femenino',
                divStyle: {marginRight:'2rem'}
              },
              {
                id: `mas_${index}`,
                value: 'M',
                span: 'Masculino'
              }
            ]}>
          </RadioButtonsComponent>
        </div>

        { !underage && <div className="clientForm__control input-field">
          <input
            type="number"
            autoComplete="off"
            id={`numCelular_${index}`}
            name={`numCelular`}
            value={data.numCelular}
            onChange={(e) => handleChange(e)}
            maxLength={11}
            pattern="[0-9]*"
            inputMode="numeric"
          />
          <label htmlFor={`numCelular_${index}`} className={`${isDataLoaded && data.numCelular && data.numCelular.length > 0 ? 'active':''}`}>Celular</label>
        </div> }

        { !underage && <div>
          <div className="clientForm__control input-field is-optional2" style={{marginBottom: '0px'}}>
            <input
              type="text"
              autoComplete="off"
              id={`correoElectronico_${index}`}
              name={`correoElectronico`}
              value={data.correoElectronico}
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor={`correoElectronico_${index}`} className={`${isDataLoaded && data.correoElectronico && data.correoElectronico.length > 0  ? 'active':''}`}>Correo Electrónico</label>
            {/* <div>(opcional)</div> */}
          </div>
          {errors['correoElectronico'] && <div className="errorCustom">Correo inválido</div>}
        </div> }

        { code === "RG" && (
          <>
          <FormContext {...methods}>
          <Ubigeo
            nameUbigeo={nameUbigeo}
            setNameUbigeo={setNameUbigeo}
            setUbigeoCode={() => {}}
            setUbigeoCodeObject={() => {}}
            errors={errors}
          />
          </FormContext>
          </>
          )
          
          }

        <div className="column-2">
          <div className="clientForm__control input-field fondo--1">
            <select
              name={`idRelacion`}
              value={data.idRelacion}
              onChange={(e) => handleChange(e)}
            >
              <option value="" disabled selected>
                Relación
              </option>
              {relations
                .filter((e) => e.value != null)
                .map(
                  (
                    e,
                    i //.filter(e=>e.value!=null)
                  ) => (
                    <option key={i} value={e.value}>
                      {e.description}
                    </option>
                  )
                )}
            </select>
          </div>
          <div className="clientForm__control input-field percent">
            <input
              type="text"
              autoComplete="off"
              id={`porcentaje_${index}`}
              name={`porcentaje`}
              value={data.porcentaje}
              onChange={(e) => handleChange(e)}
              pattern="[0-9]*"
              inputMode="numeric"
              onBlur={handleCalcOnBlur}
            />
            <div className="tooltip">
              La suma del porcentaje de los beneficiarios debe ser igual a 100%.
            </div>
            <label htmlFor={`porcentaje_${index}`}>% de beneficio</label>
          </div>

        </div>

        { code === 'RG' && <div>
        <div className="clientForm__control input-field percent">
            <input
              type="text"
              autoComplete="off"
              id={`address_${index}`}
              name={`address`}
              value={data.address}
              onChange={(e) => handleChange(e)}
              onBlur={handleCalcOnBlur}
            />
            <label htmlFor={`address_${index}`}>Dirección</label>
          </div>
        </div>}
      </div>
    </div>
  );
};
